import { useState } from "react";
import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [selected, setSelected] = useState("");
  const selectedUrl = categories.find((c) => c.id === selected)?.url || "";

  return (
    <section className="px-4 md:px-6 py-12 md:py-16">
      <div className="text-center max-w-2xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{t("home.dropdownTitle")}</h2>
        <p className="mt-3 text-foreground-600">{t("home.dropdownSubtitle")}</p>
      </div>

      <div className="mt-8 max-w-xl mx-auto flex flex-col sm:flex-row gap-3">
        <div className="relative flex-1">
          <select
            value={selected}
            onChange={(e) => setSelected(e.target.value)}
            className="w-full appearance-none rounded-md border border-background-300 bg-background-50 px-4 py-3 pr-10 text-sm text-foreground-800 cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400"
          >
            <option value="" disabled>
              {t("common.selectCategory")}
            </option>
            {categories.map((c) => (
              <option key={c.id} value={c.id}>
                {t(`cat.${c.id}`)}
              </option>
            ))}
          </select>
          <i className="ri-arrow-down-s-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-500 pointer-events-none"></i>
        </div>

        <a
          href={selectedUrl || undefined}
          target="_blank"
          rel="noopener nofollow"
          aria-disabled={!selectedUrl}
          className={`whitespace-nowrap inline-flex items-center justify-center gap-2 rounded-md px-6 py-3 text-sm font-semibold transition-colors ${
            selectedUrl
              ? "bg-primary-500 text-background-50 hover:bg-primary-600 cursor-pointer"
              : "bg-background-200 text-foreground-400 cursor-not-allowed"
          }`}
        >
          {t("common.browseCategories")}
          <i className="ri-arrow-right-up-line"></i>
        </a>
      </div>
    </section>
  );
}